import "core-js/modules/web.btoa.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.map.js";
import Vue from 'vue';
import { v4 as uuidv4 } from 'uuid';
var $t = Vue.prototype.$t;
var key = function key(str) {
  return str + '_' + window.btoa(Date.now() + Math.random());
};
// 1、单行文本
// 2、多行文本
// 3、说明
// 4、图片
// 5、单选
// 6、多选
// 7、日期
// 8、日期区间
// 9、金额
// 10、数字
// 11、地址
// 12、部门
// 13、附件
// 14、签名
// 预览组件导入
var _import = function _import(path) {
  return function () {
    return import("../components/preview/".concat(path));
  };
};
// Form组件导入
var fImport = function fImport(path) {
  return function () {
    return import("../components/control/".concat(path));
  };
};
// 控制组件
export var control = [{
  groupName: 'i18n.70f4a15ce69c445fb334b4886525c6b9',
  list: [{
    type: 1,
    name: 'i18n.52899eb6352b4465ad950f4136e13da3',
    icon: 'icon-danhangwenben'
  }, {
    type: 2,
    name: 'i18n.4684ed76804c4a39a59fc60fcc49369c',
    icon: 'icon-duohangwenben'
  }, {
    type: 3,
    name: 'work_rule_9',
    icon: 'icon-shuoming'
  }, {
    type: 4,
    name: 'i18n.148076e59bb2465799f8ded1a2500fc9',
    icon: 'icon-tupian'
  }, {
    type: 5,
    name: 'i18n.2f3e0f384dce4628b3452aca18178fc1',
    icon: 'icon-danxuan'
  }, {
    type: 6,
    name: 'i18n.74efa2c06b8544daa4331f3a8280770d',
    icon: 'icon-duoxuan'
  }, {
    type: 7,
    name: '307',
    icon: 'icon-riqi'
  }, {
    type: 8,
    name: 'i18n.a965e3ee9aac446cbb58bc5831777b12',
    icon: 'icon-riqiqujian'
  }, {
    type: 9,
    name: 'i18n.3b5b5e0c61f749e7bc76237ae255829e',
    icon: 'icon-jine'
  }, {
    type: 10,
    name: 'i18n.9b38925fec4d4fcda56bd0b18c840727',
    icon: 'icon-shuzi'
  }]
}, {
  groupName: '402',
  list: [{
    type: 11,
    name: 'i18n.8ec422762b474941939ba6e0b8c61a29',
    icon: 'icon-dizhi'
  }, {
    type: 12,
    name: '19',
    icon: 'icon-bumen'
  }, {
    type: 13,
    name: 'attachment',
    icon: 'icon-fujian'
  }, {
    type: 14,
    name: 'i18n.85e8bb3c28f343039c20c2852a0ed9c5',
    icon: 'icon-qianzi'
  }]
}];

// Preview 组件
var previewCompoents = [[1, _import('singleLine')], [2, _import('mText')], [3, _import('explain')], [4, _import('cImg')], [5, _import('select')], [6, _import('select')], [7, _import('select')], [8, _import('dateRange')], [9, _import('singleLine')], [10, _import('singleLine')], [11, _import('address')], [12, _import('depart')], [13, _import('depart')], [14, _import('sign')]];
export var comEnum = new Map(previewCompoents);

// Form 组件
export var formCom = new Map([[1, fImport('text')], [2, fImport('text')], [3, fImport('explain')], [4, fImport('text')], [5, fImport('select')], [6, fImport('select')], [7, fImport('cDate')], [8, fImport('dateRegion')], [9, fImport('money')], [10, fImport('text')], [11, fImport('address')], [12, fImport('depart')], [13, fImport('file')], [14, fImport('text')]]);

// 基础数据
export var componentBaseData = new Map([[1, function () {
  return {
    valueKey: key('text'),
    name: $t('i18n.361d281ecff146d0a84fadd79c97462f'),
    default: '',
    tips: $t('90'),
    require: false
  };
}], [2, function () {
  return {
    valueKey: key('textarea'),
    name: $t('ae1f07ba'),
    default: '',
    tips: $t('90'),
    require: false
  };
}], [3, function () {
  return {
    valueKey: key('explain'),
    name: $t('work_rule_9'),
    default: '',
    tips: $t('work_rule_9'),
    require: true
  };
}], [4, function () {
  return {
    valueKey: key('image'),
    name: $t('i18n.148076e59bb2465799f8ded1a2500fc9'),
    default: '',
    tips: $t('1f07baeb'),
    require: false
  };
}], [5, function () {
  return {
    valueKey: key('select'),
    name: $t('i18n.2f3e0f384dce4628b3452aca18178fc1'),
    default: '',
    tips: $t('221'),
    require: false,
    options: [{
      id: uuidv4(),
      label: ''
    }, {
      id: uuidv4(),
      label: ''
    }, {
      id: uuidv4(),
      label: ''
    }]
  };
}], [6, function () {
  return {
    valueKey: key('mSelect'),
    name: $t('i18n.74efa2c06b8544daa4331f3a8280770d'),
    default: '',
    tips: $t('221'),
    require: false,
    options: [{
      id: uuidv4(),
      label: ''
    }, {
      id: uuidv4(),
      label: ''
    }, {
      id: uuidv4(),
      label: ''
    }]
  };
}], [7, function () {
  return {
    valueKey: key('date'),
    name: $t('307'),
    default: '',
    tips: $t('221'),
    require: true,
    dateType: 2,
    // 日期类型 int 1->公历年月日 2->公历日月年 3->佛历年月日 4->佛历日月年
    timeType: 2 // 时间 int 1->不添加时间 2->上午/下午 3->时:分
  };
}], [8, function () {
  return {
    name: $t('i18n.a965e3ee9aac446cbb58bc5831777b12'),
    startValueKey: key('startDate'),
    startName: $t('1101'),
    // 标签
    tips: $t('221'),
    // 提示文本
    endValueKey: key('endDate'),
    endName: $t('1102'),
    // 标签
    longValueKey: key('long'),
    longName: $t('i18n.c85c8a722341451d987b81dbb8323df7'),
    // 标签
    require: false,
    // 是否必填 true：必填 false:非必填
    dateType: 2,
    // 日期类型 int 1->公历年月日 2->公历日月年 3->佛历年月日 4->佛历日月年
    timeType: 2,
    // 时间 int 1->不添加时间 2->上午/下午 3->时:分
    startDefault: '',
    endDefault: '',
    isEditDuration: true // 是否可编辑 true 允许 false 不允许
  };
}], [9, function () {
  return {
    valueKey: key('money'),
    name: $t('i18n.3b5b5e0c61f749e7bc76237ae255829e'),
    default: '',
    tips: $t('e1f07bae'),
    require: false,
    currency: 'CNY',
    // 货币IOS代码
    isThousandth: true,
    // 是否显示千分位 true 显示 false 不显示
    precision: 2,
    // 保留几位数 不保留传递0 该字段传递int类型
    isPrecision: false
  };
}], [10, function () {
  return {
    valueKey: key('number'),
    name: $t('i18n.9b38925fec4d4fcda56bd0b18c840727'),
    default: '',
    tips: $t('90'),
    require: true
  };
}], [11, function () {
  return {
    valueKey: key('area'),
    // 国家地区
    detailValueKey: key('detail'),
    // 详细地址
    name: $t('i18n.8ec422762b474941939ba6e0b8c61a29'),
    countryDefault: '',
    detailDefault: '',
    countryTips: $t('i18n.049cd651aad140b5afcce654f409dd1c'),
    detailTips: $t('i18n.1bf7f74e53fd49a8a5f8bcdbf3000460'),
    countryRequire: true,
    detailRequire: true,
    automatic: false,
    // 是否开启定位
    detailLocation: true // 是否显示详细地址 true 显示 false 不显示
  };
}], [12, function () {
  return {
    valueKey: key('depart'),
    name: $t('19'),
    tips: $t('90'),
    require: true,
    //  single 单选 multiple 多个
    optionalQuantity: 'single',
    default: {
      // 默认值 如果没有传递空
      // 0、表示申请人部门 1、表示指定部门
      type: 0,
      departmentList: [
        // 当type为0时 改值为空，
      ]
    }
  };
}], [13, function () {
  return {
    valueKey: key('file'),
    name: $t('attachment'),
    default: '',
    require: false,
    fileType: [],
    // 文件类型
    maxUploadFiles: 2,
    // 上传附件的最大文件数
    maxUploadSize: 10 // 上传文件的大小 单个文件大小 还是所有文件的总大小？
  };
}], [14, function () {
  return {
    valueKey: key('sign'),
    name: $t('i18n.85e8bb3c28f343039c20c2852a0ed9c5'),
    default: '',
    tips: $t('80164ef1'),
    require: false
  };
}]]);

// 日期类型
export var dateTypeOptions = [{
  type: 1,
  label: $t('baa59647')
}, {
  type: 2,
  label: $t('aa596471')
}, {
  type: 3,
  label: $t('a596471c')
}, {
  type: 4,
  label: $t('596471c8')
}];
export var timeOptions = [{
  type: 1,
  label: $t('20b32bd3')
}, {
  type: 3,
  label: $t('0b32bd3c')
}, {
  type: 2,
  label: $t('b32bd3ca')
}];
export var uploadFileType = ['.pdf', '.jpg', '.png', '.xls', '.doc', '.gif'];
export var defaultFlowsLogo = {
  type: 2,
  name: '',
  explain: '',
  audit_type: 0,
  logo: {
    name: 'icon-tongyong',
    // 与本地存储的logo 映射id
    color: '#1592ff' // logo 颜色
  }
};

// 注意这里顺序不能乱
export var basicComponents = [{
  name: 'work_rule_13',
  component: function component() {
    return import('../../basic');
  }
}, {
  name: 'i18n.716fa7154ecf4a0cbd5b3245ada8cd7a',
  component: function component() {
    return import('../../form');
  }
}, {
  name: 'work_rule_14',
  component: function component() {
    return import('../../design');
  }
}];

// 审批流初始化基础信息
export var baseInfo = function baseInfo() {
  return {
    // 1补卡, 2请假, 3加班, 4离职, 5出差
    audit_type: 0,
    // 分组
    group_id: '',
    // 说明
    remark: '',
    // 是否允许撤销通过，0，不可撤销，1 可以撤销
    is_allow_cancel: 1,
    // 1未审批前可撤销，2审批流未完成前可撤销，3审批完成后可撤销
    allow_type: 1,
    // 审批完成后多少天后不允许撤销
    allow_cancel_days: 0,
    // 可见范围
    visible: {
      // 0 全员可见 1 非全员可见
      toAll: 0,
      staff: [],
      department: []
    },
    // 默认审批流Logo
    logo: {
      name: 'icon-tongyong',
      color: '#1592ff'
    },
    // 审批流名称
    name: ''
  };
};

// 初始化form
export var initForm = function initForm() {
  return [{
    id: uuidv4(),
    attribute: componentBaseData.get(1)(),
    type: 1
  }];
};